import type { ImageDemonstrationData } from "@/types/storyboard";

export interface ResolvedImageDescription {
  title: string | null;
  description: string;
}

/**
 * Reads an image description in either shape: `{ title, description }`, or the
 * bare markdown string older courses carry — those have no title, so the
 * caption is all there is and the block stays untitled.
 */
export const resolveImageDescription = (
  description: ImageDemonstrationData | string
): ResolvedImageDescription => {
  if (typeof description === "string") {
    return { title: null, description: description.trim() };
  }

  return {
    title: description.title?.trim() || null,
    description: description.description?.trim() ?? "",
  };
};
